/**
 * Cœur de la résolution i18n, partagé par le runtime (LanguageManager.t) et le
 * build (tâche gulp `injectI18n`). Les deux DOIVENT produire exactement la même
 * chaîne : le build écrit le texte dans le HTML statique et le runtime le
 * réécrit au chargement — la moindre divergence (espace insécable, fallback)
 * provoquerait un saut de texte visible.
 *
 * Ce module doit rester sans dépendance DOM ni Node pour être importable des
 * deux côtés (esbuild d'un côté, gulpfile ESM de l'autre).
 */

/**
 * Typographie française : espace insécable avant la ponctuation double. Le
 * pattern cherche une espace ORDINAIRE — une insécable déjà présente dans le
 * JSON est laissée telle quelle.
 */
export function applyTypography(value, lang) {
	if (lang !== 'fr' || typeof value !== 'string') return value;
	return value.replace(/ ([!?:;])/g, ' $1');
}

/**
 * Résout une clé pointée (`home.title`) dans l'arbre de traductions.
 * Renvoie la clé elle-même si elle est absente : chaque appelant décide du
 * niveau d'alerte (le runtime garde le fallback HTML, le build loggue).
 */
export function resolve(translations, lang, key) {
	const keys = key.split('.');
	let value = translations[lang];

	for (const k of keys) {
		if (value == null || typeof value !== 'object') return key;
		value = value[k];
		if (!value) return key;
	}

	return applyTypography(value, lang);
}
